<!-- Lock widget - always render wrapper, button visibility controlled by shouldShowLockStatusButton() -->
<div class="project-lock-wrapper">
  @if (shouldShowLockStatusButton()) {
    <button
      mat-button
      class="lock-status"
      [ngClass]="{
        locked: isLocked(),
        'locked-by-other': isLocked() && !isCurrentEditor(),
        'locked-by-me': isLocked() && isCurrentEditor(),
      }"
      [matMenuTriggerFor]="lockMenu"
      [matTooltip]="getLockTooltip()"
    >
      <div class="lock-content">
        <mat-icon>{{ isLocked() ? "lock" : "lock_open" }}</mat-icon>
        <span>{{ getLockStatusText() }}</span>
      </div>
      <!-- User avatar shown only when locked -->
      @if (isLocked()) {
        <div class="lock-avatar">
          @if (!currentEditor()?.nickname && !currentEditor()?.username) {
            <mat-icon>account_circle</mat-icon>
          }
          @if (currentEditor()?.nickname || currentEditor()?.username) {
            <div class="avatar-circle">
              {{ getAvatarInitials() }}
            </div>
          }
        </div>
      }
      <div class="lock-separator"></div>
      <div class="lock-dropdown">
        <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
      </div>
    </button>
  }
  <mat-menu #lockMenu="matMenu">
    <!-- Show lock option only if user can perform lock operations and project is not locked -->
    @if (shouldShowLockButton()) {
      <button mat-menu-item (click)="toggleLock()">
        <mat-icon>lock</mat-icon>
        <span>Lock Project</span>
      </button>
    }

    <!-- Show unlock option only if user can unlock and project is locked -->
    @if (shouldShowUnlockButton()) {
      <button mat-menu-item (click)="toggleLock()">
        <mat-icon>lock_open</mat-icon>
        <span>{{
          shouldUseForceUnlock() ? "Force Unlock Project" : "Unlock Project"
        }}</span>
      </button>
    }

    <!-- Keep project locked checkbox - only show when project is locked by current user -->
    @if (isLocked() && isCurrentEditor()) {
      <mat-divider></mat-divider>
    }
    @if (isLocked() && isCurrentEditor()) {
      <div mat-menu-item class="checkbox-menu-item">
        <mat-checkbox
          [(ngModel)]="keepProjectLocked"
          (click)="$event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()"
          (keydown.space)="$event.stopPropagation()"
          class="keep-locked-checkbox"
          [attr.aria-label]="'Keep project locked'"
        >
          Keep project locked
        </mat-checkbox>
      </div>
    }

    <!-- Information items for locked states - show for all users -->
    @if (isLocked() && !canUnlockProject()) {
      <div mat-menu-item disabled class="locked-by-info">
        <div class="lock-info-column">
          <div class="locked-by-label">Locked by:</div>
          <div class="locked-by-name">
            {{ projectLockedBy() || "another user" }}
          </div>
          @if (currentEditor()?.username) {
            <div class="locked-by-email">
              {{ currentEditor()?.username }}
            </div>
          }
        </div>
      </div>
    }

    <!-- Information for users who can't perform lock operations - show for all users -->
    @if (!isLocked() && !canPerformLockOperations()) {
      <div mat-menu-item disabled>
        <mat-icon>info</mat-icon>
        <span>Insufficient permissions to lock</span>
      </div>
    }

    <!-- Show lock status info when not on head version -->
    @if (!isCurrentVersionHeadVersion() && projectId) {
      <div mat-menu-item disabled>
        <mat-icon>info</mat-icon>
        <span>Lock/unlock is only available for the head version (0.0)</span>
      </div>
    }
  </mat-menu>
</div>
